import { getHttpStatus } from '@evidentid/gateway-api-client';

import {
    REVERT_CONFLICT_MESSAGE,
    REVERT_FORBIDDEN_MESSAGE,
    REVERT_NOT_REVERTABLE_MESSAGE,
} from '@/modules/entity-actions-review/constants';

/** Readable copy for the revert failures the API distinguishes, or null when the generic
 * persisting-error handler should take the error instead.
 *
 * A 403 arrives as an XhrError carrying `reason`, because the gateway client intercepts that
 * status before the response body can be read; a 400 or 409 has no such interceptor, so the
 * rejection is the parsed response body with the status stamped on it, read with `getHttpStatus`.
 * A 400 means the action's type can never be reverted; a 409 means this particular action cannot
 * be reverted right now -- reverted concurrently, or owned by an entity that has since been
 * deactivated. The body does not separate those cleanly, so all of them map to one message.
 */
export function getRevertErrorMessage(error: any): string | null {
    const status = getHttpStatus(error);
    if (status === 409) {
        return REVERT_CONFLICT_MESSAGE;
    }
    if (error?.reason === 'forbidden' || status === 403) {
        return REVERT_FORBIDDEN_MESSAGE;
    }
    if (status === 400) {
        return typeof error?.message === 'string' && error.message
            ? error.message
            : REVERT_NOT_REVERTABLE_MESSAGE;
    }
    return null;
}
